import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import { bankoYetkiVar } from '../yetki';
import './HastaKayit.css';

// BANKO MODÜLÜ — HASTA KAYIT (kullanıcı talebi: 2026-09-20).
// VB6 karşılığı: Banko_VB6\KAYT2.frm "Hasta Rehberi". CHK (KARTKOD=1) hasta kartları.
//
// Düzen: solda ARAMA + sonuç listesi, sağda KART (KİMLİK sekmesi) ve ÖZET sekmesi.
// VB6'dan farklar (kullanıcı kararları): silme yerine İPTAL işareti, fotoğraf yok,
// özet salt okunur (cihaz hareketleri hariç), jokersiz arama "içinde geçen" olarak çalışır.

const KIMLIK_TURLERI = [
  [0, 'TC Kimlik No'], [1, 'Pasaport No'], [2, 'Yabancı Kimlik'], [3, 'Kimlik Yok'],
];
const MEDENI = [['B', 'Bekar'], ['E', 'Evli'], ['D', 'Dul'], ['?', '?']];

// ULKELER.SKRS: TÜRKİYE CUMHURİYETİ = 9980 (VB6 de 'TR' değerini kabul ediyor).
const trUyrukMu = (uyruk) => String(uyruk ?? '') === '9980' || String(uyruk ?? '') === 'TR';

const bosKart = {
  kayitNo: 0, uyruk: '9980', kimlikTuru: 0, kimlikNo: '', adSoy: '', dogYer: '', dogTar: '',
  kanGrubu: '?', cins: 'E', google: 0, gelisTuru: '', adres: '', sehir: '', ilce: '',
  tel: '', cepTel: '', email: '', notlar: '', anne: '', baba: '', medeni: '?',
  egitim: 'Bilinmiyor', vip: false, iptal: false,
};

const para = (v) => (Number(v) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const trTarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');
const isoTarih = (d) => (d ? String(d).slice(0, 10) : '');

// Telefonlar CHK'da maskeli metin olarak durur: 0-5xx-xxx-xx-xx (VB6 ile aynı).
const telRakam = (s) => {
  let d = String(s || '').replace(/\D/g, '');
  if (d && d[0] !== '0') d = `0${d}`;
  return d.slice(0, 11);
};
const telGoster = (d) => [d.slice(0, 1), d.slice(1, 4), d.slice(4, 7), d.slice(7, 9), d.slice(9, 11)].filter(Boolean).join('-');

function HastaKayit() {
  const [secenek, setSecenek] = useState(null);
  const [ilceler, setIlceler] = useState([]);
  const [arama, setArama] = useState({ ad: '', tc: '', tel: '', kayitNo: '' });
  const [iptalliler, setIptalliler] = useState(false);
  const [sonuc, setSonuc] = useState([]);
  const [kart, setKart] = useState(null);         // görüntülenen kart
  const [form, setForm] = useState(null);         // düzenleme / yeni kayıt formu
  const [mod, setMod] = useState('izle');         // izle | yeni | duzenle
  const [sekme, setSekme] = useState('kimlik');   // kimlik | ozet
  const [ozet, setOzet] = useState(null);
  const [bilgi, setBilgi] = useState('');
  const [hata, setHata] = useState('');
  const [onayMesaji, setOnayMesaji] = useState('');
  const [iptalOnay, setIptalOnay] = useState(false);
  // Haklar süzgeci (VB6 SSPanel3): varsayılan kullanılmamış haklar (kullanıcı talebi: 2026-09-20).
  const [hakFiltre, setHakFiltre] = useState('kullanilmadi');
  // Liste altı işlemleri: SMS penceresi ve santral işaretleme onayı.
  const [smsAcik, setSmsAcik] = useState(false);
  const [smsMetni, setSmsMetni] = useState('');
  const [santralOnay, setSantralOnay] = useState(false);
  const [islemde, setIslemde] = useState(false);

  useEffect(() => {
    api.get('/banko/hasta/secenekler')
      .then(({ data }) => setSecenek(data))
      .catch(err => setHata(err.response?.data?.hata || 'Seçenekler alınamadı.'));
  }, []);

  // Durum mesajları kendiliğinden silinir (Randevu Ekranı'ndaki gibi).
  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 6000);
    return () => clearTimeout(z);
  }, [bilgi]);

  // Ekran içi yetkiler VB6 ile aynı (kullanıcı kararı: 2026-09-20) — TEKN.VEZNE1/2/3:
  //   1 = ekrana giriş + yeni kayıt · 2 = değiştir · 3 = sil (web'de İPTAL).
  const yYeni = bankoYetkiVar(1);
  const yDegistir = bankoYetkiVar(2);
  const ySil = bankoYetkiVar(3);
  const yetkiNotu = 'Bu işlem için yetkili değilsiniz.';

  const aktif = mod === 'yeni' || mod === 'duzenle';
  const g = form ?? kart ?? bosKart;
  const zorunlu = (alan) => !!secenek?.zorunlular?.[alan];

  const ilceleriYukle = useCallback(async (sehir) => {
    if (!sehir) { setIlceler([]); return; }
    try {
      const { data } = await api.get('/banko/hasta/ilceler', { params: { sehir } });
      setIlceler(data);
    } catch { setIlceler([]); }
  }, []);

  useEffect(() => { ilceleriYukle(g.sehir); }, [g.sehir, ilceleriYukle]);

  // Kimlik türü uyrukla hep uyumlu kalsın: TC uyrukta yalnızca TC Kimlik No, yabancı uyrukta
  // TC Kimlik No seçilemez. (Uyruk hangi yolla değişirse değişsin tür kendiliğinden düzelir.)
  useEffect(() => {
    if (!form) return;
    const tr = trUyrukMu(form.uyruk);
    const tur = Number(form.kimlikTuru);
    // TC uyrukta tek seçenek olduğu için doğrudan TC Kimlik No; yabancı uyrukta seçenek birden
    // fazla olduğundan boş bırakılır ve personel seçer (kullanıcı kararı: 2026-09-20).
    if (tr && tur !== 0) setForm(f => ({ ...f, kimlikTuru: 0 }));
    if (!tr && form.kimlikTuru === 0) setForm(f => ({ ...f, kimlikTuru: '' }));
  }, [form]);

  const ara = async () => {
    setHata(''); setOnayMesaji('');
    const p = {
      ad: arama.ad.trim(), tc: arama.tc.trim(), tel: arama.tel.trim(),
      kayitNo: Number(arama.kayitNo) || 0, iptalliler,
    };
    if (!p.ad && !p.tc && !p.tel && !p.kayitNo) { setHata('Arama için en az bir alan doldurun.'); return; }
    if (p.ad && p.ad.replace(/\*/g, '').length < 3) { setHata('* haricinde en az 3 harf yazmalısınız.'); return; }
    try {
      const { data } = await api.get('/banko/hasta/ara', { params: p });
      setSonuc(data);
      if (data.length === 0) setBilgi('Bu bilgilerle hasta kaydı bulunamadı. "➕ Yeni Kayıt" ile açabilirsiniz.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Arama yapılamadı.');
    }
  };

  const kartAc = async (kayitNo) => {
    setHata(''); setOnayMesaji(''); setIptalOnay(false); setMod('izle'); setForm(null);
    try {
      const { data } = await api.get(`/banko/hasta/${kayitNo}`);
      setKart({ ...data, dogTar: isoTarih(data.dogTar) });
      setOzet(null);
      if (sekme === 'ozet') ozetYukle(kayitNo);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta kartı alınamadı.');
    }
  };

  const ozetYukle = async (kayitNo) => {
    try {
      const { data } = await api.get(`/banko/hasta/${kayitNo}/ozet`);
      setOzet(data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta özeti alınamadı.');
    }
  };

  const sekmeSec = (s) => {
    setSekme(s);
    if (s === 'ozet' && kart && !ozet) ozetYukle(kart.kayitNo);
  };

  const yeniKayit = () => {
    setMod('yeni'); setSekme('kimlik'); setKart(null); setOzet(null);
    // VB6 NEWKAY: yeni kayıtta il/ilçe varsayılanla (ilceler.DEF=1) gelir (kullanıcı talebi: 2026-09-20).
    setForm({
      ...bosKart,
      adSoy: arama.ad.replace(/\*/g, '').trim(),
      kimlikNo: arama.tc.trim(),
      sehir: secenek?.varsayilanIl ?? '',
      ilce: secenek?.varsayilanIlce ?? '',
    });
    setHata(''); setOnayMesaji('');
  };

  const duzenle = () => {
    if (!kart) { setHata('Öncelikle bilgileri değiştirilecek olan hastayı işaretlemelisiniz.'); return; }
    setMod('duzenle'); setSekme('kimlik'); setForm({ ...kart }); setHata(''); setOnayMesaji('');
  };

  const vazgec = () => { setMod('izle'); setForm(null); setHata(''); setOnayMesaji(''); };

  const deg = (alan, deger) => {
    setForm(f => {
      const y = { ...f, [alan]: deger };
      // Uyruk TC ise yalnızca TC Kimlik No; TC değilse TC Kimlik No seçilemez (kullanıcı kuralı: 2026-09-20).
      if (alan === 'uyruk') {
        const tr = trUyrukMu(deger);
        if (tr) y.kimlikTuru = 0;                       // tek seçenek: TC Kimlik No
        else if (y.kimlikTuru === 0) y.kimlikTuru = '';  // seçenek birden fazla: personel seçsin
      }
      return y;
    });
    setOnayMesaji(''); setHata('');
  };

  const kaydet = async (onay) => {
    if (form.kimlikTuru === '' || form.kimlikTuru == null) {
      setHata('Lütfen KİMLİK TÜRÜNÜ seçiniz (Pasaport No, Yabancı Kimlik ya da Kimlik Yok).');
      return;
    }
    setHata(''); setIslemde(true);
    const govde = {
      ...form,
      dogTar: form.dogTar || null,
      google: Number(form.google) || 0,
      kimlikTuru: Number(form.kimlikTuru),
      onay,
    };
    try {
      const { data } = mod === 'yeni'
        ? await api.post('/banko/hasta', govde)
        : await api.put(`/banko/hasta/${form.kayitNo}`, govde);
      if (data.onayMesaji) { setOnayMesaji(data.onayMesaji); return; }
      setBilgi(mod === 'yeni' ? `Hasta kaydedildi. Hasta No: ${data.kayitNo}` : 'Hasta bilgileri güncellendi.');
      setMod('izle'); setForm(null);
      await kartAc(data.kayitNo);
      if (arama.ad || arama.tc || arama.tel || arama.kayitNo) ara();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt yapılamadı.');
      setOnayMesaji('');
    } finally {
      setIslemde(false);
    }
  };

  const iptalEt = async (geriAl) => {
    setHata(''); setIslemde(true);
    try {
      const { data } = await api.post(`/banko/hasta/${kart.kayitNo}/iptal`, null, { params: { geriAl } });
      setBilgi(data.mesaj);
      setIptalOnay(false);
      await kartAc(kart.kayitNo);
      ara();
    } catch (err) {
      setHata(err.response?.data?.hata || 'İşlem yapılamadı.');
      setIptalOnay(false);
    } finally {
      setIslemde(false);
    }
  };

  // --- VB6 KAYT2 liste altı butonları ---
  const randevulariBul = () => { setSekme('ozet'); if (kart && !ozet) ozetYukle(kart.kayitNo); };

  const tumListe = async (aktarilmamis) => {
    setHata('');
    if (!window.confirm('Tüm hasta listesini görmek istiyor musunuz?')) return;
    try {
      const { data } = await api.get('/banko/hasta/tum-liste', { params: { aktarilmamis } });
      setSonuc(data);
      setBilgi(`${data.length} hasta listelendi.`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Liste alınamadı.');
    }
  };

  const borcSor = async () => {
    setHata('');
    try {
      const { data } = await api.get(`/banko/hasta/${kart.kayitNo}/ozet`);
      setOzet(data);
      setBilgi(data.bakiye > 0 ? `Hastanın ${para(data.bakiye)} TL borcu bulunmaktadır.`
        : data.bakiye < 0 ? `Hastanın ${para(-data.bakiye)} TL alacağı bulunmaktadır.`
          : 'Hastanın borcu bulunmamaktadır.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Bakiye alınamadı.');
    }
  };

  // VB6 Command7 (Excel) + Command12 (telefon listesi) birlikte — GERÇEK .xlsx (ExcelJS).
  // Başlık satırı dondurulur, sütunlar süzgeçli, TC ve telefonlar METİN biçiminde (2026-09-21).
  const exceleAktar = async () => {
    setBilgi('Excel dosyası hazırlanıyor...');
    const ExcelJS = (await import('exceljs')).default;
    const kitap = new ExcelJS.Workbook();
    kitap.creator = 'FizyofiPlus';
    kitap.created = new Date();
    const sayfa = kitap.addWorksheet('Hasta Listesi', {
      views: [{ state: 'frozen', ySplit: 3 }],
      pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
    });

    const sutun = [
      { header: 'Hasta No', key: 'kayitNo', width: 11 },
      { header: 'Hasta Adı Soyadı', key: 'adSoy', width: 34 },
      { header: 'TC Kimlik', key: 'tcKimlik', width: 16 },
      { header: 'Cep Telefonu', key: 'cepTel', width: 18 },
      { header: 'Sabit Telefon', key: 'tel', width: 18 },
      { header: 'Doğum Tarihi', key: 'dogTar', width: 14 },
      { header: 'Şehir', key: 'sehir', width: 16 },
      { header: 'İlçe', key: 'ilce', width: 18 },
      { header: 'Durum', key: 'durum', width: 10 },
    ];
    sayfa.columns = sutun;

    // 1. satır başlık, 2. satır bilgi, 3. satır sütun adları.
    sayfa.spliceRows(1, 0, [], []);
    sayfa.mergeCells(1, 1, 1, sutun.length);
    sayfa.mergeCells(2, 1, 2, sutun.length);
    const b1 = sayfa.getCell('A1');
    b1.value = 'FizyofiPlus · Hasta Listesi';
    b1.font = { size: 15, bold: true, color: { argb: 'FF1F2F46' } };
    sayfa.getRow(1).height = 24;
    const b2 = sayfa.getCell('A2');
    b2.value = `${new Date().toLocaleDateString('tr-TR')} · ${sonuc.length} kayıt`;
    b2.font = { size: 10, color: { argb: 'FF6B7A8C' } };

    const basSatir = sayfa.getRow(3);
    sutun.forEach((s, i) => { basSatir.getCell(i + 1).value = s.header; });
    basSatir.height = 20;
    basSatir.eachCell(h => {
      h.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      h.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F2F46' } };
      h.alignment = { vertical: 'middle' };
      h.border = { bottom: { style: 'thin', color: { argb: 'FF8C99A8' } } };
    });

    sonuc.forEach((h, i) => {
      const r = sayfa.addRow({
        kayitNo: h.kayitNo,
        adSoy: (h.adSoy || '').trim(),
        tcKimlik: (h.tcKimlik || '').trim(),
        cepTel: (h.cepTel || '').trim(),
        tel: (h.tel || '').trim(),
        dogTar: trTarih(h.dogTar),
        sehir: (h.sehir || '').trim(),
        ilce: (h.ilce || '').trim(),
        durum: h.iptal ? 'İPTAL' : 'Aktif',
      });
      // TC ve telefonlar metin: Excel bilimsel gösterime çevirmesin, baştaki sıfır düşmesin.
      ['C', 'D', 'E', 'F'].forEach(k => { r.getCell(k).numFmt = '@'; });
      if (i % 2) r.eachCell(c => { c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F6FA' } }; });
      r.eachCell(c => { c.border = { bottom: { style: 'hair', color: { argb: 'FFD6DCE4' } } }; });
    });

    sayfa.autoFilter = { from: { row: 3, column: 1 }, to: { row: 3, column: sutun.length } };

    const veri = await kitap.xlsx.writeBuffer();
    const url = URL.createObjectURL(new Blob([veri], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `hasta-listesi-${new Date().toISOString().slice(0, 10)}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
    setBilgi(`${sonuc.length} kayıt Excel dosyasına aktarıldı.`);
  };


  const santraleAktar = async () => {
    setIslemde(true);
    try {
      const { data } = await api.post('/banko/hasta/santrale-aktar', { kayitNolar: sonuc.map(h => h.kayitNo) });
      setBilgi(data.mesaj);
      setSantralOnay(false);
    } catch (err) {
      setHata(err.response?.data?.hata || 'İşaretleme yapılamadı.');
    } finally {
      setIslemde(false);
    }
  };

  const smsYolla = async () => {
    setIslemde(true); setHata('');
    try {
      const { data } = await api.post(`/banko/hasta/${kart.kayitNo}/sms`, { mesaj: smsMetni });
      setBilgi(data.mesaj);
      setSmsAcik(false);
    } catch (err) {
      setHata(err.response?.data?.hata || 'SMS yollanamadı.');
    } finally {
      setIslemde(false);
    }
  };

  // --- Alan yardımcıları (düzenlenebilir / salt okunur aynı görünüm) ---
  const Metin = ({ etiket, alan, uzunluk = 100, zor }) => (
    <div className={zor ? 'hk-alan zorunlu' : 'hk-alan'}>
      <span>{etiket}</span>
      {aktif
        ? <input value={g[alan] ?? ''} maxLength={uzunluk} onChange={e => deg(alan, e.target.value)} />
        : <b>{g[alan] || '—'}</b>}
    </div>
  );

  const Liste = ({ etiket, alan, secenekler, zor, bosMetin = 'SEÇİNİZ' }) => (
    <div className={zor ? 'hk-alan zorunlu' : 'hk-alan'}>
      <span>{etiket}</span>
      {aktif ? (
        <select value={g[alan] ?? ''} onChange={e => deg(alan, e.target.value)}>
          {/* Boş satır yalnızca "henüz seçilmedi" göstergesi; seçilemez (2026-09-20). */}
          <option value="" disabled>{bosMetin}</option>
          {secenekler.map(s => (Array.isArray(s)
            ? <option key={s[0]} value={s[0]}>{s[1]}</option>
            : <option key={s} value={s}>{s}</option>))}
        </select>
      ) : <b>{(() => {
        const v = g[alan];
        const bul = secenekler.find(s => (Array.isArray(s) ? String(s[0]) === String(v) : s === v));
        return (Array.isArray(bul) ? bul[1] : bul) || v || '—';
      })()}</b>}
    </div>
  );

  const Telefon = ({ etiket, alan, zor }) => (
    <div className={zor ? 'hk-alan zorunlu' : 'hk-alan'}>
      <span>{etiket}</span>
      {aktif
        ? <input value={telGoster(telRakam(g[alan]))} inputMode="numeric" placeholder="0-___-___-__-__"
                 onChange={e => deg(alan, telGoster(telRakam(e.target.value)))} />
        : <b>{(g[alan] || '').trim() && telRakam(g[alan]).length === 11 ? telGoster(telRakam(g[alan])) : '—'}</b>}
    </div>
  );

  const kimlikEtiketi = KIMLIK_TURLERI.find(k => String(k[0]) === String(g.kimlikTuru))?.[1] ?? 'TC Kimlik No';

  return (
    <div className="hk">
      <div className="hk-serit">
        <h2 className="hk-baslik">🧑‍⚕️ Hasta Kayıt<span> · Banko Modülü</span></h2>
        <div className={`hk-durum${hata ? ' hata' : bilgi ? ' bilgi' : ''}`} title={hata || bilgi || ''}>{hata || bilgi}</div>
      </div>

      <div className="hk-duzen">
        {/* ============================ SOL: ARAMA ============================ */}
        <aside className="card hk-sol">
          <strong className="hk-kutu-baslik">HASTA ARA</strong>
          <div className="hk-arama">
            <label><span>Hasta No</span>
              <input value={arama.kayitNo} inputMode="numeric"
                     onChange={e => setArama(a => ({ ...a, kayitNo: e.target.value.replace(/\D/g, '') }))}
                     onKeyDown={e => e.key === 'Enter' && ara()} /></label>
            <label><span>Hasta Adı</span>
              <input value={arama.ad} placeholder="en az 3 harf · * joker"
                     onChange={e => setArama(a => ({ ...a, ad: e.target.value }))}
                     onKeyDown={e => e.key === 'Enter' && ara()} /></label>
            <label><span>TC Kimlik</span>
              <input value={arama.tc} inputMode="numeric" maxLength={11}
                     onChange={e => setArama(a => ({ ...a, tc: e.target.value.replace(/\D/g, '') }))}
                     onKeyDown={e => e.key === 'Enter' && ara()} /></label>
            <label><span>Telefon</span>
              <input value={arama.tel} inputMode="numeric"
                     onChange={e => setArama(a => ({ ...a, tel: e.target.value }))}
                     onKeyDown={e => e.key === 'Enter' && ara()} /></label>
          </div>
          <label className="hk-iptalliler">
            <input type="checkbox" checked={iptalliler} onChange={e => setIptalliler(e.target.checked)} />
            İptal edilmiş kayıtlar da görünsün
          </label>
          <div className="hk-arama-dugme">
            <button className="btn btn-primary" onClick={ara}>🔎 ARA</button>
            <button className="btn btn-secondary" onClick={yeniKayit} disabled={!yYeni} title={yYeni ? '' : yetkiNotu}>➕ Yeni Kayıt</button>
          </div>

          <div className="hk-sonuc">
            <table>
              <thead><tr><th>No</th><th>Hasta</th><th>Doğum</th></tr></thead>
              <tbody>
                {sonuc.length === 0 && <tr><td colSpan={3} className="hk-bos">Arama yapınız.</td></tr>}
                {sonuc.map(h => (
                  <tr key={h.kayitNo} onClick={() => kartAc(h.kayitNo)}
                      className={`${kart?.kayitNo === h.kayitNo ? 'secili' : ''}${h.iptal ? ' iptalli' : ''}`}
                      title={h.iptal ? 'İptal edilmiş kayıt' : ''}>
                    <td>{h.kayitNo}</td>
                    <td>{h.adSoy}{h.iptal ? ' (iptal)' : ''}</td>
                    <td>{trTarih(h.dogTar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {sonuc.length > 0 && <div className="hk-sayac">{sonuc.length} kayıt</div>}

          {/* VB6 KAYT2'de listenin altındaki buton şeridi (kullanıcı talebi: 2026-09-20). */}
          <div className="hk-islemler">
            <button className="hk-ikon" onClick={randevulariBul} disabled={!kart}
                    title={kart ? 'Hastanın randevuları' : 'Önce hasta seçin'}>📅</button>
            <button className="hk-ikon" onClick={() => { setSmsMetni(''); setSmsAcik(true); }} disabled={!kart}
                    title={kart ? 'Hastaya SMS yolla' : 'Önce hasta seçin'}>📩</button>
            <button className="hk-ikon" onClick={() => tumListe(false)} title="Tüm hasta listesi">📂</button>
            <button className="hk-ikon" onClick={borcSor} disabled={!kart}
                    title={kart ? 'Borcu var mı?' : 'Önce hasta seçin'}>☎</button>
            <button className="hk-ikon" onClick={exceleAktar} disabled={sonuc.length === 0}
                    title="Listeyi Excel'e aktar (telefonlar dahil)">📊</button>
            <button className="hk-ikon" onClick={() => setSantralOnay(true)} disabled={sonuc.length === 0 || !yDegistir}
                    title={yDegistir ? 'Listedekileri santrale aktarıldı olarak işaretle' : yetkiNotu}>🔄</button>
          </div>

        </aside>

        {/* ============================ SAĞ: KART ============================ */}
        <section className="hk-sag">
          <div className="hk-sekmeler">
            <button className={`hk-sekme${sekme === 'kimlik' ? ' aktif' : ''}`} onClick={() => sekmeSec('kimlik')}>KİMLİK BİLGİLERİ</button>
            <button className={`hk-sekme${sekme === 'ozet' ? ' aktif' : ''}`} onClick={() => sekmeSec('ozet')} disabled={!kart}>
              TOPLU İŞLEM ÖZETİ
            </button>
            <div className="hk-sekme-bosluk" />
            {kart && !aktif && (
              <span className="hk-kart-bas">
                {kart.iptal && <em className="hk-iptal-rozet">İPTAL EDİLMİŞ KAYIT</em>}
                {kart.vip && <em className="hk-vip-rozet">VIP</em>}
                <b>{kart.adSoy}</b> · Hasta No {kart.kayitNo}
              </span>
            )}
            {mod === 'yeni' && <span className="hk-kart-bas"><b>YENİ HASTA KAYDI</b></span>}
          </div>

          {sekme === 'kimlik' && (
            <div className="card hk-kart">
              {!kart && !aktif && <p className="hk-bos-not">Soldan hasta arayıp seçin ya da ➕ Yeni Kayıt ile yeni hasta açın.</p>}

              {(kart || aktif) && (
                <>
                  <div className="hk-alanlar">
                    <div className="hk-sutun">
                      <Liste etiket="Uyruk" alan="uyruk" bosMetin="SEÇİNİZ"
                             secenekler={(secenek?.uyruklar ?? []).map(u => [u.kod, u.adi])} />
                      {/* TC uyruklu: yalnızca TC Kimlik No. Yabancı uyruklu: TC Kimlik No seçilemez. */}
                      <Liste etiket="Kimlik Türü" alan="kimlikTuru" bosMetin="SEÇİNİZ"
                             secenekler={trUyrukMu(g.uyruk)
                               ? KIMLIK_TURLERI.filter(k => k[0] === 0)
                               : KIMLIK_TURLERI.filter(k => k[0] !== 0)} />
                      <Metin etiket={kimlikEtiketi} alan="kimlikNo" uzunluk={30} zor={zorunlu('tcKimlik')} />
                      <Metin etiket="Adı - Soyadı" alan="adSoy" zor />
                      <Metin etiket="Doğum Yeri" alan="dogYer" uzunluk={50} zor={zorunlu('dogYer')} />
                      <div className={zorunlu('dogTar') ? 'hk-alan zorunlu' : 'hk-alan'}>
                        <span>Doğum Tarihi</span>
                        {aktif
                          ? <input type="date" value={g.dogTar || ''} onChange={e => deg('dogTar', e.target.value)} />
                          : <b>{trTarih(g.dogTar) || '—'}{g.dogTar ? ` · ${yas(g.dogTar)} yaşında` : ''}</b>}
                      </div>
                      <Liste etiket="Kan Grubu" alan="kanGrubu" secenekler={secenek?.kanGruplari ?? []} zor={zorunlu('kanGrubu')} />
                      <Liste etiket="Cinsiyeti" alan="cins" secenekler={[['E', 'E'], ['K', 'K']]} zor />
                      <Liste etiket="Geliş Türü" alan="gelisTuru" secenekler={secenek?.gelisTurleri ?? []} zor={zorunlu('gelisTuru')} />
                      <Liste etiket="Google Yorum" alan="google" secenekler={[[0, 'Yapmadı'], [1, 'Yaptı']]} />
                    </div>

                    <div className="hk-sutun">
                      <Metin etiket="Adresi" alan="adres" uzunluk={250} zor={zorunlu('adres')} />
                      <Liste etiket="Şehir" alan="sehir" secenekler={secenek?.iller ?? []} zor={zorunlu('sehirIlce')} />
                      <Liste etiket="İlçe" alan="ilce" secenekler={ilceler} zor={zorunlu('sehirIlce')} />
                      <Telefon etiket="Sabit Telefon" alan="tel" zor={zorunlu('telefon')} />
                      <Telefon etiket="Cep Telefonu" alan="cepTel" zor={zorunlu('telefon')} />
                      <Metin etiket="E-Mail" alan="email" uzunluk={50} zor={zorunlu('email')} />
                      <Metin etiket="Anne Adı" alan="anne" uzunluk={50} zor={zorunlu('anne')} />
                      <Metin etiket="Baba Adı" alan="baba" uzunluk={50} zor={zorunlu('baba')} />
                      <Liste etiket="Medeni Hali" alan="medeni" secenekler={MEDENI} zor={zorunlu('medeni')} />
                      <Liste etiket="Eğitim" alan="egitim" secenekler={secenek?.egitimler ?? []} zor={zorunlu('egitim')} />
                    </div>
                  </div>

                  <div className="hk-alan hk-genis">
                    <span>Özel Notlar</span>
                    {aktif
                      ? <textarea rows={2} maxLength={250} value={g.notlar ?? ''} onChange={e => deg('notlar', e.target.value)} />
                      : <b>{g.notlar || '—'}</b>}
                  </div>

                  {aktif && (
                    <label className="hk-vip">
                      <input type="checkbox" checked={!!g.vip} onChange={e => deg('vip', e.target.checked)} /> VIP hasta
                    </label>
                  )}

                  <p className="hk-not">Sarı etiketli alanlar zorunludur. Zorunluluk kuralları ZORUNLULAR tablosundan gelir.</p>

                  {onayMesaji && (
                    <div className="hk-onay">
                      <p>{onayMesaji}</p>
                      <div className="hk-dugmeler">
                        <button className="btn btn-secondary" onClick={() => setOnayMesaji('')} disabled={islemde}>Hayır</button>
                        <button className="btn btn-primary" onClick={() => kaydet(true)} disabled={islemde}>Evet, devam et</button>
                      </div>
                    </div>
                  )}

                  {iptalOnay && (
                    <div className="hk-onay">
                      <p>{kart.adSoy} isimli hastanın kaydı İPTAL edilecek. Kayıt silinmez, listelerde görünmez ve
                        istendiğinde geri alınabilir. Onaylıyor musunuz?</p>
                      <div className="hk-dugmeler">
                        <button className="btn btn-secondary" onClick={() => setIptalOnay(false)} disabled={islemde}>Vazgeç</button>
                        <button className="btn btn-danger" onClick={() => iptalEt(false)} disabled={islemde}>Evet, iptal et</button>
                      </div>
                    </div>
                  )}

                  {!onayMesaji && !iptalOnay && (
                    <div className="hk-dugmeler">
                      {!aktif && (
                        <>
                          <button className="btn btn-primary" onClick={yeniKayit} disabled={!yYeni}
                                  title={yYeni ? '' : yetkiNotu}>➕ Yeni Kayıt</button>
                          <button className="btn btn-secondary" onClick={duzenle} disabled={!kart || !yDegistir}
                                  title={yDegistir ? '' : yetkiNotu}>✎ Değiştir</button>
                          {kart && !kart.iptal && (
                            <button className="btn btn-danger" onClick={() => setIptalOnay(true)} disabled={!ySil}
                                    title={ySil ? '' : yetkiNotu}>🚫 Kaydı İptal Et</button>
                          )}
                          {kart?.iptal && (
                            <button className="btn btn-secondary" onClick={() => iptalEt(true)} disabled={islemde || !ySil}
                                    title={ySil ? '' : yetkiNotu}>↩ İptali Kaldır</button>
                          )}
                        </>
                      )}
                      {aktif && (
                        <>
                          <button className="btn btn-secondary" onClick={vazgec} disabled={islemde}>Vazgeç</button>
                          <button className="btn btn-primary" onClick={() => kaydet(false)} disabled={islemde}>
                            {islemde ? 'Kaydediliyor...' : mod === 'yeni' ? '💾 Kaydet' : '💾 Güncelle'}
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {sekme === 'ozet' && kart && (
            <div className="hk-ozet">
              <div className={`card hk-bakiye${ozet && ozet.bakiye > 0 ? ' borc' : ozet && ozet.bakiye < 0 ? ' alacak' : ''}`}>
                {!ozet && 'Yükleniyor...'}
                {ozet && ozet.bakiye > 0 && `Hastanın ${para(ozet.bakiye)} TL borcu bulunmaktadır.`}
                {ozet && ozet.bakiye < 0 && `Hastanın ${para(-ozet.bakiye)} TL alacağı bulunmaktadır.`}
                {ozet && ozet.bakiye === 0 && 'Hastanın borcu bulunmamaktadır.'}
              </div>

              {[['Kabul İşlemleri', ozet?.kabuller, 'Hizmet Noktası', 'Açıklama', true, false],
                ['Faturaları', ozet?.faturalar, 'Evrak Türü', 'Açıklama', true, false],
                ['Tahsilatları', ozet?.tahsilatlar, 'Evrak Türü', 'Açıklama', true, false],
                ['Randevuları', ozet?.randevular, 'Uzman', 'Hizmet', false, false],
                // VB6 SSPanel3: haklar Kullanılmamış / Kullanılmış / Tümü süzgeciyle listelenir.
                ['Hakları', hakSuzgecli(ozet?.haklar, hakFiltre), 'Hizmet', 'Protokol', true, true]]
                .map(([ad, liste, s1, s2, tutarVar, suzgecVar]) => (
                <div className="card hk-ozet-kutu" key={ad}>
                  <strong className="hk-kutu-baslik">
                    {ad} {liste ? `(${liste.length})` : ''}
                    {suzgecVar && (
                      <select className="hk-suzgec" value={hakFiltre} onChange={e => setHakFiltre(e.target.value)}>
                        <option value="kullanilmadi">Kullanılmadı</option>
                        <option value="kullanildi">Kullanıldı</option>
                        <option value="tumu">Tümü</option>
                      </select>
                    )}
                  </strong>
                  <div className="hk-ozet-tablo">
                    <table>
                      <thead>
                        <tr>
                          <th>Tarih</th><th>{s1}</th><th>{s2}</th>
                          {tutarVar && <th className="sag">Tutar</th>}<th>Durum</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(liste ?? []).length === 0 && <tr><td colSpan={5} className="hk-bos">Kayıt yok.</td></tr>}
                        {(liste ?? []).map((r, i) => (
                          <tr key={i}>
                            <td>{trTarih(r.tar)}{r.saat ? ` ${r.saat}` : ''}</td>
                            <td>{r.metin}</td>
                            <td className="hk-ack">{r.metin2}</td>
                            {tutarVar && <td className="sag">{para(r.tutar)}</td>}
                            <td>{r.durum}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>

      {/* Onay ve SMS pencereleri MODAL: sol sütunda yer kaplamasınlar, liste uzun kalabilsin
          (kullanıcı talebi: 2026-09-20). */}
      {santralOnay && (
        <Pencere baslik="Santrale Aktarıldı İşareti" kapat={() => setSantralOnay(false)}>
          <p className="hk-modal-metin">
            Ekrandaki <b>{sonuc.length}</b> hasta "santrale aktarıldı" olarak işaretlenecek. Onaylıyor musunuz?
          </p>
          <div className="hk-dugmeler">
            <button className="btn btn-secondary" onClick={() => setSantralOnay(false)} disabled={islemde}>Vazgeç</button>
            <button className="btn btn-primary" onClick={santraleAktar} disabled={islemde}>Evet, işaretle</button>
          </div>
        </Pencere>
      )}

      {smsAcik && kart && (
        <Pencere baslik={`SMS · ${kart.adSoy}`} kapat={() => setSmsAcik(false)}>
          <p className="hk-modal-metin">Telefon: <b>{kart.cepTel}</b></p>
          <textarea rows={4} maxLength={160} value={smsMetni} placeholder="SMS metni (en fazla 160 karakter)"
                    onChange={e => setSmsMetni(e.target.value)} />
          <div className="hk-sms-sayac">{160 - smsMetni.length} karakter kaldı</div>
          {hata && <div className="hata-kutu">{hata}</div>}
          <div className="hk-dugmeler">
            <button className="btn btn-secondary" onClick={() => setSmsAcik(false)} disabled={islemde}>Vazgeç</button>
            <button className="btn btn-primary" onClick={smsYolla} disabled={islemde || !smsMetni.trim()}>📩 Yolla</button>
          </div>
        </Pencere>
      )}
    </div>
  );
}

// Basit modal pencere (Randevu Ekranı'ndaki Pencere'nin sade hali).
function Pencere({ baslik, kapat, children }) {
  useEffect(() => {
    const tus = (e) => { if (e.key === 'Escape') kapat(); };
    window.addEventListener('keydown', tus);
    return () => window.removeEventListener('keydown', tus);
  }, [kapat]);

  return (
    <div className="hk-modal-zemin" onMouseDown={e => { if (e.target === e.currentTarget) kapat(); }}>
      <div className="hk-modal" role="dialog" aria-modal="true">
        <div className="hk-modal-bas">
          <strong>{baslik}</strong>
          <button onClick={kapat} aria-label="Kapat">✕</button>
        </div>
        <div className="hk-modal-govde">{children}</div>
      </div>
    </div>
  );
}

// Haklar süzgeci: sunucudan tümü gelir, listeleme burada süzülür.
function hakSuzgecli(liste, filtre) {
  if (!liste) return liste;
  if (filtre === 'kullanildi') return liste.filter(h => h.durum === 'Kullanıldı');
  if (filtre === 'kullanilmadi') return liste.filter(h => h.durum !== 'Kullanıldı');
  return liste;
}

// Doğum tarihinden yaş (VB6'daki SUREHESAPLA'nın sade hali).
function yas(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const b = new Date();
  let y = b.getFullYear() - d.getFullYear();
  const ay = b.getMonth() - d.getMonth();
  if (ay < 0 || (ay === 0 && b.getDate() < d.getDate())) y -= 1;
  return y;
}

export default HastaKayit;
